<template>
  <pt-third-vendors-detail class="pt-third-vendors-detail__withData" v-loading="loading" :vendor="currentVendor"></pt-third-vendors-detail>
</template>

<script>
import PtThirdVendorsDetail from './index'
export default {
  name: 'pt-third-vendors-detail__withData',
  components: {
    'pt-third-vendors-detail': PtThirdVendorsDetail
  },
  data () {
    return {
      loading: false,
      currentVendor: {}
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$store.dispatch('getVendor', this.$route.params.id).then(data => {
        this.loading = false
        if (data.invoiceProvides) {
          data.invoiceProvides = data.invoiceProvides.map(e => e.invoice)
        }
        this.currentVendor = data
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
